import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import HalfDonutChart from "./HalfDonutChart ";
import { useSelector } from "react-redux";

export default function KitInstalledChart() {
  const { DashboardListingData } = useSelector(
    (state) => state.DASHBOARDLISTING
  );
  const [radial, setRadial] = useState({
    series: [0],
    options: {
      chart: {
        height: 350,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 15,
            size: "70%",
          },
          startAngle: -90,
          endAngle: 90,
          dataLabels: {
            name: {
              show: true,
              fontSize: "16px",
            },
            value: {
              show: true,
              color: "#16161D",
              fontSize: "30px",
              fontWeight: "bold",
            },
          },
        },
      },
      labels: ["0"],
      colors: ["#006AFF"],
      stroke: {
        lineCap: "round",
      },
    },
  });
  const [months, setMonths] = useState([
    {
      id: 1,
      month: "Jan",
      value: 0,
      progressDifference: 10,
    },
    {
      id: 2,
      month: "Feb",
      value: 0,
      progressDifference: 0,
    },
    {
      id: 3,
      month: "Mar",
      value: 0,
      progressDifference: 0,
    },
    {
      id: 4,
      month: "Apr",
      value: 100,
      progressDifference: 0,
    },
    {
      id: 5,
      month: "May",
      value: 0,
      progressDifference: 0,
    },
    {
      id: 6,
      month: "Jun",
      value: 0,
      progressDifference: 0,
    },
    {
      id: 7,
      month: "July",
      value: 0,
      progressDifference: 0,
    },
    {
      id: 8,
      month: "Aug",
      value: 0,
      progressDifference: 0,
    },
    {
      id: 9,
      month: "Sep",
      value: 0,
      progressDifference: 0,
    },
    {
      id: 10,
      month: "Oct",
      value: 0,
      progressDifference: 0,
    },
    {
      id: 11,
      month: "Nov",
      value: 0,
      progressDifference: 0,
    },
    {
      id: 12,
      month: "Dec",
      value: 0,
      progressDifference: 0,
    },
  ]);
  useEffect(() => {
    const safetyKitsData =
      DashboardListingData?.data?.safety_kit_installed_details ?? [];
    if (safetyKitsData?.length > 0) {
      const reliancePercentage =
        safetyKitsData[safetyKitsData.length - 1].reliance_percentage;
      const monthsData = safetyKitsData.map((item, index) => ({
        id: index + 1,
        month: item.month,
        value: item.reliance_percentage,
        progressDifference: item.progressDifference,
      }));
      const labels = monthsData.map((month) => month.progressDifference);
      setMonths(monthsData);
      const activePercentage = labels[labels.length - 1];

      setRadial((prevState) => ({
        ...prevState,
        series: [Math.round(reliancePercentage)],
        options: {
          ...prevState.options,
          labels: [activePercentage],
          plotOptions: {
            ...prevState.options.plotOptions,
            radialBar: {
              ...prevState.options.plotOptions.radialBar,
              dataLabels: {
                ...prevState.options.plotOptions.radialBar.dataLabels,
                name: {
                  show: true,
                  formatter: (val) => {
                    return `${val}% ${activePercentage > 0 ? "↑" : "↓"}`;
                  },
                  color:
                    activePercentage > 0
                      ? "#42BD53"
                      : activePercentage < 0
                      ? "#FF0000"
                      : "grey",
                },
              },
            },
          },
        },
      }));
    }
  }, [DashboardListingData]);
  return (
    <>
      <h5 className="text-center text_gray mb-0" style={{ color: "#16161D" }}>
        Safety Kits Installed
      </h5>
      <div className="position-relative">
        <ReactApexChart
          options={radial.options}
          series={radial.series}
          type="radialBar"
          height={350}
        />
        <p className="safety-kit-style m-0">Us vs Competitors</p>
      </div>
      <div className="mt-3">
        <HalfDonutChart months={months} setradialBardata={setRadial} />
      </div>
    </>
  );
}
